// extracted by mini-css-extract-plugin
module.exports = {"time":"FormattedDateTime_time__2a1rX"};